import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { HRPage } from "@/components/hr/hr-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/hr",
  component: HRPageGuard,
});

function HRPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as { role?: string })?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <HRPage />;
}
